<template>
  <v-row>
    <v-col>
      <v-btn-toggle v-model="loadDuration" group dense>
        <v-btn :value="false"> Profile </v-btn>
        <v-btn :value="true"> Load Duration Curve </v-btn>
      </v-btn-toggle>
      <PlotlyWrapper v-if="chartData" :data="chartData" :layout="chartLayout"></PlotlyWrapper>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ChartLine",
  mixins: [],
  components: {
    PlotlyWrapper: () => import("@/components/charts/PlotlyWrapper.vue"),
  },
  props: {
    data: {
      type: [Object, Array],
      required: false,
      default: () => null,
    },
    options: {
      type: Object,
      required: true,
    },
    nameKey: {
      type: String,
      required: false,
      default: "name",
    },
    valueKey: {
      type: String,
      required: false,
      default: "value",
    },
    startDate: {
      type: Date,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      profileIds: null,
      loadDuration: false,
    };
  },
  computed: {
    chartData() {
      let data = this.datasets;
      if (data == null) return null;
      data = this.mapDatasets(data);
      data = data.map((e) => ({
        ...e,
        type: "scatter",
        mode: "lines",
      }));

      if (this.loadDuration) {
        data = data.map((e) => ({
          ...e,
          y: e.y.toSorted((a, b) => b - a),
          fill: "tozeroy",
        }));
      }
      return data;
    },
    datasets() {
      if (this.data == null) return null;
      if (!Array.isArray(this.data)) return [this.data];
      return this.data;
    },
    chartLayout() {
      return {
        xaxis: {
          rangeslider: true,
        },
        yaxis: {
          title: "Demand (MW)",
        },
        showlegend: false,
        margin: {
          l: 50,
          r: 50,
          b: 50,
          t: 50,
          pad: 4,
        },
      };
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    mapDatasets(datasets) {
      if (!Array.isArray(datasets[0][this.valueKey])) return null;
      let data = null;
      if (typeof datasets[0][this.valueKey][0] !== "object") {
        data = [
          {
            y: datasets[0][this.valueKey],
            x: datasets[0][this.valueKey].map((_, idx) => idx),
          },
        ];
      } else {
        data = [
          {
            y: datasets[0][this.valueKey].map((e) => e.value),
            x: datasets[0][this.valueKey].map((e) => e.date || e.timestamp),
          },
        ];
      }
      return data;
    },
  },
};
</script>

<style></style>
